import React from 'react';
import { ShieldCheck, Clock3, Building2, BadgeCheck } from 'lucide-react';
import './About.css';

import qualipacLogo from '../assets/logo-qualipac-RGE.PNG';
import capebLogo from '../assets/capeb.jpg';

const FEATURES = [
  {
    icon: <ShieldCheck size={26} strokeWidth={1.9} />,
    title: 'Savoir-faire maîtrisé',
    desc: 'Installation en toute tranquillité avec des techniciens certifiés et expérimentés.',
  },
  {
    icon: <Clock3 size={26} strokeWidth={1.9} />,
    title: 'Réactivité maximale',
    desc: 'Intervention rapide sous 24h. Une équipe disponible et à l’écoute de vos besoins.',
  },
  {
    icon: <Building2 size={26} strokeWidth={1.9} />,
    title: 'Pour tous vos projets',
    desc: 'Des solutions adaptées aux particuliers comme aux professionnels, selon chaque besoin.',
  },
  {
    icon: <BadgeCheck size={26} strokeWidth={1.9} />,
    title: 'Prestations soignées',
    desc: 'Un travail propre, sérieux, avec des matériaux fiables et des équipements de qualité.',
  },
];

export default function About() {
  return (
    <section id="apropos" className="about">
      <div className="container">
        <div className="about__grid">
          <div className="about__left">
            <p className="about__label section-eyebrow section-eyebrow--red">
              Qui sommes-nous
            </p>

            <h2 className="about__title section-title section-title--blue">
              L&apos;expert en
              <br />
              <span className="about__title-accent">climatisation</span>
              <br />
              d&apos;Île-de-France
            </h2>

            <p className="about__text">
              SOCLIMATE est une entreprise spécialisée dans l&apos;installation,
              la maintenance et le dépannage de systèmes de climatisation et de
              pompes à chaleur.
            </p>

            <p className="about__text">
              Basés en Île-de-France, nous accompagnons les particuliers et les
              professionnels avec sérieux, rigueur et exigence de qualité.
            </p>

            <p className="about__text">
              Certifiés RGE QualiPAC et membres de la CAPEB, nous réalisons des
              installations conformes aux normes en vigueur et permettant
              l&apos;accès aux aides financières selon votre situation.
            </p>

            <div className="about__badges">
              <div className="about__badge about__badge--rge">
                <img
                  src={qualipacLogo}
                  alt="Certification RGE QualiPAC"
                  className="about__badge-logo"
                />
              </div>

              <div className="about__badge about__badge--capeb">
                <img
                  src={capebLogo}
                  alt="Membre CAPEB"
                  className="about__badge-logo"
                />
              </div>

              <a href="#certif" className="about__more-btn">
                <span className="about__more-btn-dash" />
                En savoir plus
              </a>
            </div>
          </div>

          <div className="about__right">
            <div className="about__features">
              {FEATURES.map((feature) => (
                <article className="about__feature" key={feature.title}>
                  <div className="about__feature-icon">{feature.icon}</div>

                  <div className="about__feature-content">
                    <h3 className="about__feature-title">{feature.title}</h3>
                    <p className="about__feature-desc">{feature.desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}